import { SET_APP_VERSION_STATUS } from '../actions/appVersion'

const initialState = { isOutdated: false }

const appVersion = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_VERSION_STATUS:
      return { ...state, isOutdated: action.isOutdated }
    default:
      return state
  }
}

export default appVersion
